<template>
  <div class="pop-container">
    <h3 class="pop-title">修改密码</h3>
    <transition name="fade">
      <notice :type="'error'" v-if="noticeShow">
        <template v-slot:noticeTxt>
          {{noticeWarn}}
        </template>
      </notice>
    </transition>
    <div class="pop-content">
      <div class="input-group">
        <div class="input-area">
          <input type="text"  autocomplete="off" onfocus="this.type='password'" v-model="oldPwd" placeholder="请输入当前密码"><span class="iconfont icon-lock-line"></span> 
        </div>
        <div class="input-area">
          <input type="text" autocomplete="off" onfocus="this.type='password'" v-model="newPwd" placeholder="请输入新密码"><span class="iconfont icon-lock-line"></span> 
        </div>
        <div class="input-area">
          <input type="text" autocomplete="off" onfocus="this.type='password'" v-model="newPwd2" placeholder="再次输入新密码"  @keyup.enter='resetPwd'><span class="iconfont icon-lock-line"></span>
        </div>
      </div>
      <div class="login-btn" @click.stop="resetPwd">修改密码</div>
      <p class="login-tips" @click.stop="back">返回</p>
    </div>  
    <pop-info v-if="restSuccess">
      <p>{{success}}</p>
    </pop-info>
  </div>
</template>

<script>
import md5 from 'js-md5';
import notice from './notice.vue'
import PopInfo from './popInfo.vue';
export default {
  name: 'resetPwd',
  props: {
    msg: String
  },
  components:{
    notice,
    PopInfo,
  },
  data(){
    return{
      noticeWarn:'',
      noticeShow:false,
      username:"",
      oldPwd:'',
      newPwd:'',
      newPwd2:'',
      success:'修改成功',
      restSuccess:false
    }
  },
  mounted() {
    this.getLogin()
  },
  methods: {
    getLogin(){
      let login = this.$utils.getCookie("login");
      if(login){
        let loginObj =JSON.parse(login);
        this.username = loginObj.user;
      }
    },

    //重置密码
    resetPwd(){
      if(!this.oldPwd || !this.newPwd || !this.newPwd2 ){
        this.noticeWarn ="密码不能为空";
        this.noticeShow=true;
        this.fadeOutWarn();
        return
      }

      // 两次密码是否一致
      if(this.newPwd !== this.newPwd2){
        this.noticeWarn ='两次输入的密码不一致'
        this.noticeShow=true;
        this.fadeOutWarn();
        return;
      }

      // 密码长度6-20位
      if(this.newPwd.length<6 || this.newPwd2.length>20){
        this.noticeWarn ='新密码长度为6-20位'
        this.noticeShow=true;
        this.fadeOutWarn();
        return;
      }

      var regPwdNum= /\d+/; //验证0-9的任意数字最少出现1次。
      var regPwdStr= /[a-zA-Z]+/;    //验证大小写26个字母任意字母最少出现1次。
      if(!regPwdNum.test(this.newPwd) || !regPwdStr.test(this.newPwd)){
        this.noticeWarn ='新密码必须包含数字+字母'
        this.noticeShow=true;
        this.fadeOutWarn();
        return;
      }


      let params={
        username:this.username,
        password:md5(this.oldPwd),
        newpassword:md5(this.newPwd),
      }
      this.$api.userApi.resetPwd(params).then(res=>{
        if(res.code===0){
          this.success = res.msg;
          this.restSuccess =true;
          setTimeout(() => {
            this.restSuccess = false;
            this.$emit('changeView', {viewName:'UserRights' })
          }, 2000);
        }else{
          this.noticeWarn ='原密码错误，请重新输入';
          this.noticeShow=true;
          this.fadeOutWarn();
        }
      })
          
    },
    back(){
      this.$emit("changeView",{
        viewName:"userRights"
      })
    },

    //隐藏警告提示框 
    fadeOutWarn(){
      setTimeout(() => {
        this.noticeShow=false;
      }, 2000);
    }
  },
  
}
</script>